import React, { useState, useEffect } from 'react'
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const ManageVideoCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [deleteConfirm, setDeleteConfirm] = useState({ show: false, id: null });
  const navigate = useNavigate();

  // Get auth token from localStorage
  const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  };

  const fetchCategories = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/video-categories`, {
        headers: getAuthHeaders(),
        params: { page }
      });
      
      if (response.data.status) {
        setCategories(response.data.AllVideoCategories || response.data.data || []);
        setCurrentPage(response.data.pagination?.currentPage || page);
        setTotalPages(response.data.pagination?.totalPages || 1);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_Baseurl}/admin/video-categories/${id}`, {
        headers: getAuthHeaders()
      });
      
      if (response.data.status) {
        alert('Category deleted successfully!');
        fetchCategories(currentPage); // Refresh current page
      } else {
        alert('Failed to delete category');
      }
    } catch (error) {
      console.error('Error deleting category:', error);
      alert('Error deleting category');
    }
    setDeleteConfirm({ show: false, id: null });
  };

  const handlePrevClick = () => {
    if (currentPage > 1) {
      fetchCategories(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      fetchCategories(currentPage + 1);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div>
      <div className=" m-0 p-0">
        <div className="">
          <section className="section container-fluid">
            <div className="pt-3">
              <div className="admin-section-title">
                <div className="iq-card">
                  <div className="row">
                    <div className="col-md-6">
                      <h4>
                        <i className="entypo-archive"></i> Video Categories
                      </h4>
                    </div>

                    <div className="col-md-6" align="right">
                      <Link
                        to="/admin/add-categories"
                        className="btn btn-primary"
                      >
                        <i className="fa fa-plus-circle"></i> Add Categories
                      </Link>
                    </div>
                  </div>
                  <hr />

                  <div
                    className="panel panel-primary category-panel"
                    data-collapsed="0"
                  >
                    <div className="panel-heading">
                      <div className="panel-title">
                        <p>Organize the Categories below: </p>
                      </div>

                      <div className="panel-options">
                        <Link to="#" data-rel="collapse">
                          <i className="entypo-down-open"></i>
                        </Link>
                      </div>
                    </div>

                    <div className="panel-body">
                      <div
                        id="nestable"
                        className="nested-list dd with-margins"
                      >
                        {loading ? (
                          <div className="text-center py-4">
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <p>Loading categories...</p>
                          </div>
                        ) : (
                          <table
                            className="table table-bordered iq-card text-center"
                            id="categorytbl"
                          >
                            <thead>
                              <tr className="table-header r1">
                                <th>
                                  <label>Category Image</label>
                                </th>
                                <th>
                                  <label>Video Category Name</label>
                                </th>
                                <th>
                                  <label>Uploaded by</label>
                                </th>
                                <th>
                                  <label>Actions</label>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {categories.length > 0 ? (
                                categories.map((item, key) => (
                                  <tr key={key} id={`category-${item.id}`}>
                                    <td valign="middle" className="">
                                      <img
                                        src={item.image || item.image_url || '/default-category.png'}
                                        width={100}
                                        height={100}
                                        alt={item.name}
                                        onError={(e) => {
                                          e.target.src = '/default-category.png';
                                        }}
                                      />
                                    </td>
                                    <td valign="middle">
                                      <p>{item.name}</p>
                                      <small className="text-muted">{item.upload_on}</small>
                                    </td>
                                    <td valign="middle">
                                      <span className="badge bg-secondary">
                                        {item.uploaded_by_name || 'Admin'}
                                      </span>
                                    </td>
                                    <td valign="middle">
                                      <div className="btn-group" role="group">
                                        <Link 
                                          to={`/admin/edit-categories/${item.id}`} 
                                          className="btn btn-sm btn-outline-primary"
                                          title="Edit"
                                        >
                                          <i className="fa fa-pencil-square" aria-hidden="true"></i>
                                        </Link>
                                        <button 
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() => setDeleteConfirm({ show: true, id: item.id })}
                                          title="Delete"
                                        >
                                          <i className="fa fa-trash" aria-hidden="true"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="4" className="text-center py-4">
                                    <p className="mb-0">No categories found</p>
                                    <small className="text-muted">Click 'Add Categories' to create your first category</small>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        )}

                        {/* Pagination */}
                        <div className="row text-center d-flex mt-3">
                          <div className="col-lg-4">
                            <button
                              type="button"
                              className={`btn btn-primary ${currentPage <= 1 ? 'disabled' : ''}`}
                              onClick={handlePrevClick}
                              disabled={currentPage <= 1}
                            >
                              {"<< Previous"}
                            </button>
                          </div>
                          <div className="col-lg-4">
                            <p className="mb-0">
                              Page {currentPage} of {totalPages}
                            </p>
                          </div>
                          <div className="col-lg-4">
                            <button
                              type="button"
                              className={`btn btn-primary ${currentPage >= totalPages ? 'disabled' : ''}`}
                              onClick={handleNextClick}
                              disabled={currentPage >= totalPages}
                            >
                              {"Next >>"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <input type="hidden" id="_token" name="_token" value="update" />
            </div>
          </section>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {deleteConfirm.show && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setDeleteConfirm({ show: false, id: null })}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this category? This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setDeleteConfirm({ show: false, id: null })}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger" 
                  onClick={() => handleDelete(deleteConfirm.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ManageVideoCategories